// AboutUs.js
import React from "react";
import { Link } from "react-router-dom";
import '../../styles/AboutUsStyles.css';

const AboutUs = () => {
  const imagePath = `${process.env.PUBLIC_URL}/images/userImages/AboutUs.jpg`; // Ruta a la imagen desde public

  return (
    <section
      className="about-us-section"
      style={{
        backgroundImage: `url(${imagePath})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "100vh",
      }}
    >
      <div className="about-us-content">
        <h2 className="featurette-heading">
          ¡Trabajemos juntos!
        </h2>
        <p className="lead">
          Somos una constructora comprometida con la calidad, la innovación y la
          satisfacción de nuestros clientes. Diseñamos y desarrollamos proyectos
          residenciales y comerciales que se adaptan a tus necesidades.
        </p>
        <Link to="/contact" className="btn-carousel">
          CONTÁCTANOS
        </Link>
      </div>
    </section>
  );
};

export default AboutUs;
